import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";

import "./mainContainer.css";

import LoginPage from "../Login/LoginPage";
import AdminApp from "../AdminSubapp/AdminApp";
import EmployeeApp from "../EmployeeSubapp/EmployeeApp";

// Static data
import { orders } from "../../staticData/orders";
import { menus } from "../../staticData/menus";
import { dishes as dishesStatic } from "../../staticData/dishes";
import { posts } from "../../staticData/posts";
import { configuration } from "../../staticData/configuration";
import { mediafiles } from "../../staticData/mediafiles";

const sortMenus = (a, b) => {
  let A = a.menuDate;
  let B = b.menuDate;

  if (A > B) {
    return -1;
  } else if (B > A) {
    return 1;
  } else {
    return 0;
  }
};

const MainContainer = ({
  isAuthenticated,
  userRole,
  setAuthenticated,
  setUserRole
}) => {
  // Log out
  const handleLogout = () => {
    setAuthenticated(false);
    setUserRole("");
  };

  // App-level handlers
  const [activeOrders, setActiveOrders] = useState([...orders]);
  const [isActiveOrdersLoading, setActiveOrdersLoading] = useState(false);

  const [activeUncheckedOrders, setActiveUncheckedOrders] = useState([]);

  const [allMenus, setAllMenus] = useState([...menus]);
  const [isAllMenusLoading, setIsAllMenusLoading] = useState(false);

  const [dishes, setDishes] = useState([...dishesStatic]);
  const [isDishesLoading, setDishesLoading] = useState(false);

  const [config, setConfig] = useState({ ...configuration });
  const [isConfigLoading, setIsConfigLoading] = useState(false);

  const [promos, setPromos] = useState([...posts]);
  const [mediaURLs, setMediaURLs] = useState([...mediafiles]);

  // Orders
  const handleUpdateOrderAdmin = (orderId, payload) => {
    const renewedOrders = [...activeOrders];
    const oldOrderArrayIndex = activeOrders.findIndex(
      (value) => value._id === orderId
    );

    const oldOrder = activeOrders[oldOrderArrayIndex];

    renewedOrders[oldOrderArrayIndex] = { ...oldOrder, ...payload };

    setActiveOrders((activeOrders) => [...renewedOrders]);
  };

  const handleUpdateOrderChef = async (orderId, payload) => {
    const renewedOrders = [...activeOrders];
    const oldOrderArrayIndex = activeOrders.findIndex(
      (value) => value._id === orderId
    );

    const oldOrder = activeOrders[oldOrderArrayIndex];

    renewedOrders[oldOrderArrayIndex] = { ...oldOrder, ...payload };

    setActiveOrders((activeOrders) => [...renewedOrders]);
  };

  const handleConfirmOrder = async (orderId, payload) => {
    const renewedOrders = [...activeOrders];
    const oldOrderArrayIndex = activeOrders.findIndex(
      (value) => value._id === orderId
    );

    const oldOrder = activeOrders[oldOrderArrayIndex];

    renewedOrders[oldOrderArrayIndex] = { ...oldOrder, ...payload };

    setActiveOrders((activeOrders) => [...renewedOrders]);
  };

  const handleInactivateOrder = (orderId) => {
    const renewedOrders = [...activeOrders];
    const oldOrderArrayIndex = activeOrders.findIndex(
      (value) => value._id === orderId
    );

    renewedOrders[oldOrderArrayIndex].active = false;

    setActiveOrders((activeOrders) => [...renewedOrders]);
  };

  // Menus
  const handleCreateNewMenu = (menu) => {
    let correctedMenu = { ...menu };

    correctedMenu._id = uuidv4();

    if (correctedMenu.purposeType === "print") {
      correctedMenu.websitePurpose = "";
      correctedMenu.active = false;
    }

    setAllMenus((allMenus) => [...allMenus, correctedMenu]);
  };

  const handleUpdateMenu = (id, updatedData) => {
    const workingArray = [...allMenus];
    const oldMenuArrayIndex = workingArray.findIndex(
      (value) => value._id === id
    );

    const oldMenu = workingArray[oldMenuArrayIndex];

    workingArray[oldMenuArrayIndex] = { ...oldMenu, ...updatedData };

    setAllMenus((allMenus) => [...workingArray]);
  };

  const handleToggleMenuActive = (id) => {
    const renewedAllMenus = [...allMenus];

    const oldMenuArrayIndex = allMenus.findIndex((value) => value._id === id);

    renewedAllMenus[oldMenuArrayIndex].active = renewedAllMenus[
      oldMenuArrayIndex
    ].active
      ? false
      : true;

    setAllMenus((allMenus) => [...renewedAllMenus]);
  };

  const handleDeleteMenu = (id) => {
    const renewedAllMenus = [...allMenus.filter((m) => m._id !== id)];

    setAllMenus((allMenus) => [...renewedAllMenus]);
  };

  // Dishes
  const handleDeleteDish = (dishId) => {
    const workingArray = [...dishes.filter((m) => m._id !== dishId)];

    setDishes((allMenus) => [...workingArray]);
  };

  const handleCreateDish = (dish) => {
    const dishToAdd = { ...dish };
    dishToAdd._id = Math.random().toString();

    setDishes((dishes) => [...dishes, dishToAdd]);
  };

  const handleUpdateDish = (id, updatedData) => {
    const workingArray = [...dishes];
    const oldDishArrayIndex = workingArray.findIndex(
      (value) => value._id === id
    );

    const oldDish = workingArray[oldDishArrayIndex];

    workingArray[oldDishArrayIndex] = { ...oldDish, ...updatedData };

    setDishes((dishes) => [...workingArray]);
  };

  // Posts
  const handleCreatePromopost = (newPromopost) => {
    const correctedPost = { ...newPromopost };
    correctedPost._id = uuidv4();
    setPromos((promos) => [...promos, correctedPost]);
  };

  const handleTogglePromopostActive = (id) => {
    const renewedPromos = [...promos];
    const oldPromoArrayIndex = renewedPromos.findIndex(
      (value) => value._id === id
    );

    renewedPromos[oldPromoArrayIndex].active = !renewedPromos[
      oldPromoArrayIndex
    ].active;

    setPromos((promos) => [...renewedPromos]);
  };

  const handleUpdatePromopost = (id, updatedData) => {
    const renewedPromos = [...promos];
    const oldPromoArrayIndex = renewedPromos.findIndex(
      (value) => value._id === id
    );

    renewedPromos[oldPromoArrayIndex] = {
      ...renewedPromos[oldPromoArrayIndex],
      ...updatedData
    };

    setPromos((promos) => [...renewedPromos]);
  };

  const handleDeletePromopost = (id) => {
    setPromos((promos) => promos.filter((promo) => promo._id !== id));
  };

  return (
    <div className="mainContainer__div">
      {!isAuthenticated ? (
        <LoginPage
          isAuthenticated={isAuthenticated}
          userRole={userRole}
          setAuthenticated={setAuthenticated}
          setUserRole={setUserRole}
        />
      ) : isAuthenticated && userRole === 0 ? (
        <AdminApp
          handleLogout={handleLogout}
          isAuthenticated={isAuthenticated}
          userRole={userRole}
          setAuthenticated={setAuthenticated}
          setUserRole={setUserRole}
          activeOrders={activeOrders}
          setActiveOrders={setActiveOrders}
          isActiveOrdersLoading={isActiveOrdersLoading}
          handleUpdateOrderAdmin={handleUpdateOrderAdmin}
          handleUpdateOrderChef={handleUpdateOrderChef}
          handleConfirmOrder={handleConfirmOrder}
          handleInactivateOrder={handleInactivateOrder}
          allMenus={allMenus.sort(sortMenus)}
          isAllMenusLoading={isAllMenusLoading}
          handleCreateNewMenu={handleCreateNewMenu}
          handleUpdateMenu={handleUpdateMenu}
          handleToggleMenuActive={handleToggleMenuActive}
          handleDeleteMenu={handleDeleteMenu}
          dishes={dishes}
          handleCreateDish={handleCreateDish}
          handleUpdateDish={handleUpdateDish}
          handleDeleteDish={handleDeleteDish}
          config={config}
          setConfig={setConfig}
          promos={promos}
          handleCreatePromopost={handleCreatePromopost}
          handleTogglePromopostActive={handleTogglePromopostActive}
          handleUpdatePromopost={handleUpdatePromopost}
          handleDeletePromopost={handleDeletePromopost}
          mediaURLs={mediaURLs}
          setMediaURLs={setMediaURLs}
        />
      ) : (
        <EmployeeApp
          handleLogout={handleLogout}
          isAuthenticated={isAuthenticated}
          userRole={userRole}
          setAuthenticated={setAuthenticated}
          setUserRole={setUserRole}
          activeOrders={
            activeOrders &&
            activeOrders
              .filter((o) => o.active)
              .filter((order) => order.orderType === "dailymenuOrder")
          }
          setActiveOrders={setActiveOrders}
          isActiveOrdersLoading={isActiveOrdersLoading}
          handleUpdateOrderAdmin={handleUpdateOrderAdmin}
          handleUpdateOrderChef={handleUpdateOrderChef}
          handleConfirmOrder={handleConfirmOrder}
          handleInactivateOrder={handleInactivateOrder}
          allMenus={allMenus.sort(sortMenus)}
          dishes={dishes}
          handleUpdateMenu={handleUpdateMenu}
        />
      )}
    </div>
  );
};

export default MainContainer;
